// Self-contained data for the MAV Party Needs & Services events concept website.
export const BUSINESS = {
  "slug": "mav-party-needs-services-concept",
  "media": {
    "hero": "/events/mav/09.jpg",
    "logo": null,
    "gallery": [
      "/events/mav/01.jpg",
      "/events/mav/02.jpg",
      "/events/mav/04.jpg",
      "/events/mav/05.jpg",
      "/events/mav/06.jpg",
      "/events/mav/07.jpg",
      "/events/mav/08.jpg",
      "/events/mav/10.jpg",
      "/events/mav/11.jpg"
    ]
  },
  "name": "MAV Party Needs & Services",
  "shortName": "MAV",
  "kind": "rental",
  "layout": "colorful",
  "location": "Tondo, Manila",
  "address": "212 Ampioco St., Balut, Tondo, Manila, Philippines",
  "eyebrow": "Local party energy since 2015",
  "headline": "Color, music and the details that make the party feel personal.",
  "intro": "Founder-led balloon styling, table setups, photobooths, florals and complete celebration support.",
  "lead": "Marc Anjo Valdez",
  "leadRole": "Founder / owner",
  "story": "MAV publicly identifies Marc Anjo Valdez as founder and says the business began in 2015. The company describes growing through vendor partnerships and adapting celebrations around each client’s preferences.",
  "services": [
    "Balloon decoration",
    "Table setup",
    "Photobooth",
    "Music selection",
    "Custom floral design",
    "Weddings and debuts",
    "Birthdays",
    "Corporate events"
  ],
  "proof": [
    "Founder-led since 2015",
    "Decor, photobooth and event extras",
    "Named client testimonials"
  ],
  "reviewSnapshot": "A public listing showed about 5.0/5 with 10+ reviews when checked in August 2026; three named testimonials were also available on the earlier site.",
  "reviews": [
    {
      "author": "Rizza Almera Constantino",
      "summary": "Described Anjo as kind and easy to work with and strongly recommended MAV.",
      "source": "https://mavpnseventplanner.wixsite.com/mavpnsevents",
      "explicitStars": null,
      "context": "Client testimonial"
    },
    {
      "author": "Mikee Balverde",
      "summary": "Praised easy communication, the service and the wider team.",
      "source": "https://mavpnseventplanner.wixsite.com/mavpnsevents",
      "explicitStars": null,
      "context": "Client testimonial"
    },
    {
      "author": "Lagrimas Gayona Calicsihan",
      "summary": "Highlighted flexible payment discussions, affordable décor, photobooth quality, energetic hosting and delivery of her child’s requested birthday theme.",
      "source": "https://mavpnseventplanner.wixsite.com/mavpnsevents",
      "explicitStars": null,
      "context": "Birthday story"
    }
  ],
  "contact": {
    "phone": "+63 966 952 8974",
    "phoneHref": "+639669528974",
    "email": "mavpns.eventplanner@gmail.com",
    "facebook": "https://www.facebook.com/MAVPNS/"
  },
  "sources": [
    "https://mavpnseventplanner.wixsite.com/mavpnsevents",
    "https://www.facebook.com/MAVPNS/",
    "https://www.bizippines.com/mav-party-needs-services-0966-952-8974"
  ]
};
